import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';

import Login from './pages/Login';
import RegisterPatient from './pages/RegisterPatient';
import DoctorsList from './pages/DoctorsList';
import DoctorDetail from './pages/DoctorDetail';
import CGV from './pages/CGV';
import MentionsLegales from './pages/MentionsLegales';

import PatientDashboard from './pages/patient/Dashboard';
import PatientAppointments from './pages/patient/Appointments';
import PatientRecords from './pages/patient/Records';
import PatientProfile from './pages/patient/Profile';

import DoctorDashboard from './pages/doctor/Dashboard';
import DoctorAppointments from './pages/doctor/Appointments';
import DoctorAvailability from './pages/doctor/Availability';
import DoctorProfile from './pages/doctor/Profile';
import DoctorPatients from './pages/doctor/Patients';

import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminDoctors from './pages/admin/Doctors';
import AdminPatients from './pages/admin/Patients';

function PrivateRoute({ children, role }) {
  const { user, token } = useAuthStore();
  if (!token) return <Navigate to="/login" />;
  if (role && user?.role !== role) return <Navigate to="/login" />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register/patient" element={<RegisterPatient />} />
        <Route path="/doctors" element={<DoctorsList />} />
        <Route path="/doctors/:id" element={<DoctorDetail />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />

        <Route path="/patient/dashboard" element={<PrivateRoute role="patient"><PatientDashboard /></PrivateRoute>} />
        <Route path="/patient/appointments" element={<PrivateRoute role="patient"><PatientAppointments /></PrivateRoute>} />
        <Route path="/patient/records" element={<PrivateRoute role="patient"><PatientRecords /></PrivateRoute>} />
        <Route path="/patient/profile" element={<PrivateRoute role="patient"><PatientProfile /></PrivateRoute>} />

        <Route path="/doctor/dashboard" element={<PrivateRoute role="doctor"><DoctorDashboard /></PrivateRoute>} />
        <Route path="/doctor/appointments" element={<PrivateRoute role="doctor"><DoctorAppointments /></PrivateRoute>} />
        <Route path="/doctor/availability" element={<PrivateRoute role="doctor"><DoctorAvailability /></PrivateRoute>} />
        <Route path="/doctor/profile" element={<PrivateRoute role="doctor"><DoctorProfile /></PrivateRoute>} />
        <Route path="/doctor/patients" element={<PrivateRoute role="doctor"><DoctorPatients /></PrivateRoute>} />

        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>} />
        <Route path="/admin/doctors" element={<PrivateRoute role="admin"><AdminDoctors /></PrivateRoute>} />
        <Route path="/admin/patients" element={<PrivateRoute role="admin"><AdminPatients /></PrivateRoute>} />

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}
